import shared from '../../styles/shared.module.css';
import styles from './ContactSection.module.css';
import { WHATSAPP_URL, INSTAGRAM_URL, EMAIL } from '../../constants';

import footerLogo from '../../assets/figma/page13/footer-logo.png';
import contactWhatsapp from '../../assets/figma/page13/contact-whatsapp.png';
import contactInstagram from '../../assets/figma/page13/contact-instagram.png';
import contactEmail from '../../assets/figma/page13/contact-email.png';

export function ContactSection() {
  return (
    <section id="contato" className={styles.contact}>
      <div className={`${shared.frame} ${styles.contactFrame}`}>
        <div className={styles.contactBrand}>
          <img src={footerLogo} alt="Cris Morais Arquitetura para Crianças" />
          <p>Criando ambientes que inspiram e transformam o desenvolvimento infantil.</p>
          <p className={styles.contactQuote}>"Onde mora o sonho, mora a criança...."</p>
        </div>

        <div className={styles.contactLinks}>
          <h2>Vamos Conversar?</h2>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
            <img src={contactWhatsapp} alt="" aria-hidden="true" />
            <span>
              <strong>WhatsApp</strong>
              <small>Atendimento direto</small>
            </span>
          </a>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
            <img src={contactInstagram} alt="" aria-hidden="true" />
            <span>
              <strong>@crismorais.arq</strong>
              <small>Siga no Instagram</small>
            </span>
          </a>
          <a href={`mailto:${EMAIL}`}>
            <img src={contactEmail} alt="" aria-hidden="true" />
            <span>
              <strong>Email</strong>
              <small>{EMAIL}</small>
            </span>
          </a>
        </div>
      </div>

      <div className={styles.footerBar}>
        <p>© 2026 Cris Morais - Arquitetura para Crianças. Todos direitos reservados.</p>
        <span>ARQUITETURA PARA CRIANÇAS</span>
      </div>
    </section>
  );
}
